import React from 'react';
import './GenericModal.scss';

interface GenericModalHeaderProps {
  title: string | React.ReactNode;
}

const GenericModalHeader: React.FC<GenericModalHeaderProps> = ({ title }) => (
  <div className="generic-modal-header">
    <div className="generic-modal-title">{title}</div>
  </div>
);

export default GenericModalHeader;
